import { render, staticRenderFns } from "./payOrderCard.vue?vue&type=template&id=ae64ef86&scoped=true"
import script from "./payOrderCard.vue?vue&type=script&lang=js"
export * from "./payOrderCard.vue?vue&type=script&lang=js"
import style1 from "./payOrderCard.vue?vue&type=style&index=1&id=ae64ef86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae64ef86",
  null
  
)

export default component.exports